import { IoMdEye } from 'react-icons/io';
import { useDebugValue, useEffect, useState } from 'react';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import { Button, useStepContext } from '@mui/material';
import { FcPrint } from "react-icons/fc";
import { IoMdAirplane } from "react-icons/io";
import Pagination from '@mui/material/Pagination';
import { FaWeight } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { FaTruck } from "react-icons/fa";
import { toast } from 'react-toastify';
import PaginationItem from '@mui/material/PaginationItem';
import { useMyContext } from '../../../../context/MyContext';
import '../../../../css/custom-scrollbar.css';
import Spinner from '../../../../component/spinner/spinner';
import { FaDownload } from "react-icons/fa";
import { Base_Url, forwardorderlist, shipmentList, allwarehouseslist, shipmentlabel, cancleOrder, deleteShipment, bulkshipmentlabel, Url_For_View_Document, priceEstimator } from '../../../../config/config';
import ViewAllShipment from '../../../../component/b2c/models/ViewAllShipment';
import ViewRateForwardShipment from '../../../../component/b2c/models/ViewRateForwordShipmet';
import axios from 'axios';
import { FaSave } from 'react-icons/fa';
import { CgSearch } from "react-icons/cg";
import { RxCross2 } from "react-icons/rx"
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';

const AllShipment = () => {
  const [statusFilter, setStatusFilter] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [wareHouseList, setwareHouseList] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('all orders');
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode, isToggleSidebar, setorderId } = useMyContext();
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const [selectedShipment, setSelectedShipment] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isloading, isSetLoading] = useState(false);
  const [loadingOrderId, setLoadingOrderId] = useState(null);
  const [loadingOrderIdShip, setLoadingOrderIdShip] = useState(null);
  const [loadingOrderIdCancleOrder, setLoadingOrderIdCancleOrder] = useState(null);
  const [isPopupOpenForShip, setIsPopupOpenForShip] = useState(false)
  const [searchTerm, setSearchTerm] = useState('');
  const cancleOrderApi = Base_Url + deleteShipment;
  const [loading, setLoading] = useState(false);
  const navigateForTrack = useNavigate();
  const [selectedRowsForShip, setSelectedRowsForShip] = useState([]);
  const [selectAllForShip, setSelectAllForShip] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const visibleOrders = showAll ? selectedRowsData : selectedRowsData.slice(0, 6);

  useEffect(() => {
    setData([]);
    setLimit(10);
    setCurrentPage(1);
  }, [activeTab]);


  useEffect(() => {
    const validTabs = ['manifest list', 'process order', 'Add Shipment list', 'new order', 'all orders'];
    if (validTabs.includes(activeTab)) {
      fetchOrderData();
    }
  }, [activeTab, currentPage, limit]);


  // useEffect(() => {
  //   const validTabs = [
  //     'manifest list',
  //     'process order',
  //     'Add Shipment list',
  //     'new order',
  //     'all orders'
  //   ];

  //   if (!validTabs.includes(activeTab)) return;
  //   fetchOrderData();
  //   const intervalId = setInterval(() => {
  //     fetchOrderData();
  //   }, 10000);

  //   return () => clearInterval(intervalId);

  // }, [activeTab, currentPage, limit]);



  // useEffect(() => {
  //   const validTabs = [
  //     'manifest list',
  //     'process order',
  //     'Add Shipment list',
  //     'new order',
  //     'all orders'
  //   ];

  //   if (!validTabs.includes(activeTab)) return;

  //   // Call immediately
  //   fetchOrderData();

  //   // Call every 10 seconds
  //   const intervalId = setInterval(() => {
  //     fetchOrderData();
  //   }, 10000); // 10 sec

  //   // Cleanup on tab/page change or unmount
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [activeTab, currentPage, limit]);


  const fetchOrderData = async () => {
    setLoading(true);
    // setData([]);
    try {
      setIsPageLoading(true)
      const pageNumber = Number(currentPage) || 1;
      // const limitNumber = Number(limit) || 10;
      let statusParam = '';
      if (activeTab === 'manifest list') {
        statusParam = '&status=Manifested';
      } else if (activeTab === 'process order') {
        statusParam = '&status=Pickup scheduled ';
      } else if (activeTab === 'Add Shipment list') {
        statusParam = '&status=pending';
      }
      else if (activeTab === 'new order') {
        statusParam = '&status=NewOrder';
      }

      const url = `${Base_Url}${shipmentList}?page=${pageNumber}&limit=${limit}${statusParam}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (result && result.data) {
        setData(result.data)
        setTotalOrders(result?.pagination?.totalItems);
        setIsPageLoading(false)
      } else {
        toast.error(result.message);
        setData([]);
        setIsPageLoading(false)
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error(error.message);
      setData([]);
      setIsPageLoading(false)

    } finally {
      setLoading(false); // End loading
      setIsPageLoading(false)
    }
  };

  const handleViewClick = (row) => {
    setSelectedShipment(row);
    fetchWareHouseList();
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };


  const handleViewClickForShip = (shipment) => {
    setSelectedShipment(shipment)
    setIsPopupOpenForShip(true);
  }

  const handleCloseForShip = () => {
    setIsPopupOpenForShip(false);
  };


  // download leavel
  const handlePrintLabel = async (orderId) => {
    try {
      setIsPageLoading(true)
      setLoadingOrderId(orderId);
      const response = await fetch(`${Base_Url}${shipmentlabel}`, {
        method: 'POST',
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_id: orderId }),
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        const printUrl = data?.DownloadLink;
        if (printUrl) {
          const labelPrint = Base_Url + printUrl;
          window.open(labelPrint, '_blank');
          toast.success("Shipment label downloaded successfully!");
          setIsPageLoading(false)
        }
        setLoadingOrderId(null)
      } else {
        toast.error(data.message);
        setIsPageLoading(false)
        setLoadingOrderId(null)
      }
    } catch (error) {
      toast.error('API error: ' + error.message);
      setLoadingOrderId(null)

    }
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Select only the rows that are currently shown and match filter condition (like `partner`)
      const allSelectableIndexes = data
        .map((item, idx) => item.partner ? idx : null)
        .filter(idx => idx !== null);

      setSelectedRows(allSelectableIndexes);
    } else {
      setSelectedRows([]);
    }

    setSelectAll(e.target.checked);
  };


  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      let updatedSelection;

      if (isSelected) {
        updatedSelection = prev.filter(i => i !== index);
      } else {
        updatedSelection = [...prev, index];
      }

      // Update selectAll if needed
      if (updatedSelection.length === data.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }

      return updatedSelection;
    });
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getSelectedOrderIds = () => {
    if (selectAll) {
      // If all are selected, return all order IDs
      return data.filter(shipment => shipment.partner).map(shipment => shipment.order_id);
    } else {
      // For individual selections, map correctly to the displayed items
      return selectedRows.map(index => {
        // Make sure we're accessing the correct item in currentItems
        return data[index].order_id;
      });
    }
  };

  // download lavel in bulk
  const handleDownload = async () => {
    const selectedOrderIds = getSelectedOrderIds();
    const urlForDownloadBulkLabel = Base_Url + bulkshipmentlabel;
    const payload = {
      order_ids: selectedOrderIds
    };
    const headers = {
      token: token,
      cus_id: cusid,
      'Content-Type': 'application/json',
    };
    isSetLoading(true);
    setIsPageLoading(true)
    try {
      const response = await fetch(urlForDownloadBulkLabel, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const pdf = data.DownloadLink;
        const downloadPdf = Url_For_View_Document + pdf;
        if (downloadPdf) {
          window.open(downloadPdf, "_blank")
        }
        isSetLoading(false);
        setIsPageLoading(true)
      }
      else {
        toast.error(data.message);
        isSetLoading(false);
        setIsPageLoading(true)
      }
    } catch (error) {
      console.error('Error downloading orders:', error);
      isSetLoading(false);
      setIsPageLoading(true)
    }
  };

  const handleCancelOrder = async (orderId) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to cancel this order?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No',
    });

    if (!confirmResult.isConfirmed) {
      return; // User cancelled
    }

    try {
      setIsPageLoading(true)
      setLoadingOrderIdCancleOrder(orderId); // Show loader on button
      const response = await fetch(`${cancleOrderApi}/${orderId}`, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      if (response.ok) {
        setData((prevData) => prevData.filter(item => item.order_id !== orderId));
        toast.success("Order canceled successfully!");
        setIsPageLoading(false)
      } else {
        toast.error(`Failed to cancel order: ${data.message}`);
        setIsPageLoading(false)
      }
    } catch (error) {
      toast.error(`API error: ${error.message}`);
      setIsPageLoading(false)

    } finally {
      setLoadingOrderIdCancleOrder(null);
    }
  };

  const handleShipNow = async (data) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    debugger
    const requestBody = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      address: data.address,
      product_desc: data.products_desc,
      phone: data.phone,
      city: data.city,
      state: data.state,
      country: "India",
      payment_mode: data.payment_mode,
      total_amount: data.total_amount,
      address_type: "home",
      length: data.length,
      width: data.shipment_width,
      height: data.shipment_height,
      from_pincode: data.pickup_pin_code,
      to_pincode: data.pin,
      // cod_amount: data.codAmount,
      cod_amount: data.cod_amount,
      quantity: "1",
      weight: data.weight,
      shipment_type: "Forward",
      order_id: data.order_id
    };
    setIsPageLoading(true)
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        const enrichedShipment = { ...response.data, order_id: data.order_id };
        handleViewClickForShip(enrichedShipment);
        setIsPageLoading(false)
      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
        setIsPageLoading(false)
      }

    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {

    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getFilteredCustomers = () => {
    if (!searchTerm.trim()) {
      return data;
    }

    const term = searchTerm.toLowerCase();
    return data.filter(customer => {
      return (
        // Make sure to handle potential undefined values with optional chaining
        (customer.waybill?.toString().toLowerCase().includes(term)) ||
        (customer.first_name?.toLowerCase().includes(term)) ||
        (customer.order_id?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayCustomers = getFilteredCustomers();

  const handleClick = (orderID) => {
    setorderId(orderID);
    navigateForTrack("/shipments/tracking ");
  }


  const fetchWareHouseList = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const headers = new Headers({
      'token': token,
      'cus_id': cusid,
      'Content-Type': 'application/json'
    });
    try {
      const response = await fetch(Base_Url + allwarehouseslist, {

        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = data.data.map(warehouse => ({
        value: warehouse.id,
        label: warehouse.name,
        pincode: warehouse.pincode
      }));
      setwareHouseList(transformedData)
    } catch (error) {
      console.error('Error:', error);
    }
  }

  // Handle individual row selection
  const handleRowSelectForShip = (index) => {
    const isSelected = selectedRowsForShip.includes(index);
    let newSelectedRows;
    let newSelectedData;

    if (isSelected) {
      // Remove from selection
      newSelectedRows = selectedRowsForShip.filter(i => i !== index);
      newSelectedData = selectedRowsData.filter((_, i) => selectedRowsForShip[i] !== index);
    } else {
      // Add to selection
      newSelectedRows = [...selectedRowsForShip, index];
      newSelectedData = [...selectedRowsData, displayCustomers[index]];
    }

    setSelectedRowsForShip(newSelectedRows);
    setSelectedRowsData(newSelectedData);
    setSelectAllForShip(newSelectedRows.length === displayCustomers.length);
  };

  // Handle select all checkbox
  const handleSelectAllForShip = () => {
    if (selectAllForShip) {
      // Deselect all
      setSelectedRowsForShip([]);
      setSelectedRowsData([]);
      setSelectAllForShip(false);
    } else {
      // Select all
      const allIndices = displayCustomers.map((_, index) => index);
      setSelectedRowsForShip(allIndices);
      setSelectedRowsData([...displayCustomers]);
      setSelectAllForShip(true);
    }
  };

  // Function to find the most common pincode
  const getMostCommonPincode = (selectedData) => {
    const pincodeCount = {};

    selectedData.forEach(row => {
      const pincode = row.pin;
      pincodeCount[pincode] = (pincodeCount[pincode] || 0) + 1;
    });

    // Find the pincode with maximum count
    let mostCommonPincode = '';
    let maxCount = 0;

    Object.entries(pincodeCount).forEach(([pincode, count]) => {
      if (count > maxCount) {
        maxCount = count;
        mostCommonPincode = pincode;
      }
    });

    return mostCommonPincode;
  };

  // Function to calculate total dimensions and weight
  const calculateTotalDimensions = (selectedData) => {
    const totals = selectedData.reduce((acc, row) => {
      return {
        length: acc.length + parseFloat(row.length || 0),
        width: acc.width + parseFloat(row.shipment_width || 0),
        height: acc.height + parseFloat(row.shipment_height || 0),
        weight: acc.weight + parseFloat(row.weight || 0),
        cod_amount: acc.cod_amount + parseFloat(row.cod_amount || 0)
      };
    }, {
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      cod_amount: 0
    });

    return totals;
  };

  const handleBulkShipNow = async () => {
    if (selectedRowsData.length === 0) {
      toast.error("Please select at least one order to ship");
      return;
    }

    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');

    // Calculate totals
    const totals = calculateTotalDimensions(selectedRowsData);
    const mostCommonPincode = getMostCommonPincode(selectedRowsData);

    // Get pickup pincode from first selected row (assuming all have same pickup location)
    const fromPincode = selectedRowsData[0].pickup_pin_code;

    const requestBody = {
      from_pincode: fromPincode,
      to_pincode: mostCommonPincode,
      length: totals.length,
      width: totals.width,
      height: totals.height,
      weight: totals.weight,
      shipment_type: "Forward",
      declared_value: "", // You can calculate total amount if needed
      payment_mode: selectedRowsData[0].payment_mode, // Using first row's payment mode
      cod_amount: totals.cod_amount.toString()
    };


    setIsPageLoading(true);

    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });

      if (response.data.status === "success") {
        toast.success(`${selectedRowsData.length} orders processed successfully!`);

        // Create enriched shipment data for bulk orders
        const enrichedBulkShipment = {
          ...response.data,
          // Add bulk-specific information
          bulk_order: true,
          selected_orders: selectedRowsData.map(row => row.order_id),
          total_orders: selectedRowsData.length,
          bulk_totals: totals,
          most_common_pincode: mostCommonPincode,
          // Add first order details for reference (you can modify this as needed)
          order_id: `BULK_${selectedRowsData.map(row => row.order_id).join('_')}`,
          // Include selected rows data for reference
          selectedRowsData: selectedRowsData
        };

        // Open the ViewRateForwardShipment modal with bulk data
        setSelectedShipment(enrichedBulkShipment);
        setIsPopupOpenForShip(true);

        // Clear selections after successful bulk ship
        setSelectedRowsForShip([]);
        setSelectedRowsData([]);
        setSelectAllForShip(false);

      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
      }
    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {
      setIsPageLoading(false);
    }
  };

  // Alternative approach if you want to handle bulk differently in the modal
  // You might need to modify the ViewRateForwardShipment component to handle bulk data
  const handleBulkShipNowAlternative = async () => {
    if (selectedRowsData.length === 0) {
      toast.error("Please select at least one order to ship");
      return;
    }

    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');

    // Calculate totals
    const totals = calculateTotalDimensions(selectedRowsData);
    const mostCommonPincode = getMostCommonPincode(selectedRowsData);

    // Get pickup pincode from first selected row (assuming all have same pickup location)
    const fromPincode = selectedRowsData[0].pickup_pin_code;

    const requestBody = {
      from_pincode: fromPincode,
      to_pincode: mostCommonPincode,
      length: totals.length,
      width: totals.width,
      height: totals.height,
      weight: totals.weight,
      shipment_type: "Forward",
      declared_value: "",
      payment_mode: selectedRowsData[0].payment_mode,
      cod_amount: totals.cod_amount.toString()
    };
    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });

      if (response.data.status === "success") {
        toast.success(`${selectedRowsData.length} orders processed successfully!`);

        // If your ViewRateForwardShipment modal expects the same format as individual orders,
        // you can create a merged data object representing the bulk shipment
        const bulkShipmentData = {
          ...response.data,
          // Merge information from the first selected order as primary data
          ...selectedRowsData[0],
          // Override with bulk-specific data
          order_id: selectedRowsData.map(row => row.order_id).join(', '),
          length: totals.length,
          shipment_width: totals.width,
          shipment_height: totals.height,
          weight: totals.weight,
          total_amount: selectedRowsData.reduce((sum, row) => sum + parseFloat(row.total_amount), 0),
          cod_amount: totals.cod_amount,
          pin: mostCommonPincode,
          // Add a flag to identify this as bulk shipment
          is_bulk_shipment: true,
          bulk_orders_count: selectedRowsData.length,
          bulk_orders: selectedRowsData
        };

        // Open the modal with bulk shipment data
        setSelectedShipment(bulkShipmentData);
        setIsPopupOpenForShip(true);

        // Clear selections
        setSelectedRowsForShip([]);
        setSelectedRowsData([]);
        setSelectAllForShip(false);

      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
      }
    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {
      setIsPageLoading(false);
    }
  };

  // Helper function to handle bulk shipment view (similar to handleViewClickForShip)
  const handleViewClickForBulkShip = (bulkShipmentData) => {
    setSelectedShipment(bulkShipmentData);
    setIsPopupOpenForShip(true);
  };
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}

        <FullPageLoader
          isLoading={isPageLoading}
          message="Processing your request..."
        />
        <div className={`shadow-custom-light ml-3 mt-6 mb-6 mr-6 w-full rounded-custom overflow-y-auto custom-scrollbar dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
          <button className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-4 py-2 rounded-xl h-[50px] w-full flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all duration-200">
            <FaWeight size={20} className="text-white" />
            <span className="tracking-wide">All Orders</span>
          </button>

          <div className="mb-8">
            <div className="relative group">
              {/* Hover background glow */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Input container */}
              <div className="relative flex items-center bg-white dark:bg-darkmodeColor border-2 border-gray-200 dark:border-gray-700 rounded-xl shadow-sm hover:shadow-md focus-within:shadow-lg focus-within:border-customPurple transition-all duration-300">

                {/* Search Icon */}
                <div className="pl-4 pr-3">
                  <CgSearch className="text-gray-400 dark:text-gray-300 transition-colors duration-200 group-focus-within:text-customPurple" size={20} />
                </div>

                {/* Input Field */}
                <input
                  type="text"
                  placeholder="Search by Order Id / Waybill No / Name"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="flex-1 p-4 bg-transparent outline-none dark:text-white text-gray-700 placeholder-gray-400 dark:placeholder-gray-300 text-sm font-medium"
                />

                {/* Clear Button */}
                {searchTerm && (
                  <button
                    onClick={() => handleSearchChange({ target: { value: '' } })}
                    className="mr-4 p-1 text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-red-50 dark:hover:bg-red-900/20"
                  >
                    <span className="sr-only">Clear search</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {['Add Shipment list', 'new order', 'process order', 'manifest list', 'all orders'].map((tab) => {
              const isActive = activeTab === tab;
              return (
                <button
                  key={tab}
                  onClick={() => handleTabClick(tab)}
                  className={`relative group px-4 py-3 text-sm sm:text-base font-medium rounded-xl transition-all duration-300 transform hover:scale-[1.02]
                  ${isActive
                      ? 'bg-customPurple text-white shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40'
                      : 'bg-white text-gray-700 dark:bg-[rgba(1,14,78,0.95)] dark:text-white border border-gray-200 dark:border-gray-700 hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-[rgba(1,14,78,0.9)] shadow-sm hover:shadow-md'
                    }`}
                >
                  <span className="capitalize">{tab}</span>
                  {isActive && (
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-white dark:bg-white rounded-full mt-1 transition-all duration-300" />
                  )}
                </button>
              );
            })}
            <>
              {activeTab === 'Add Shipment list' && (
                <button
                  onClick={handleBulkShipNow}
                  disabled={isPageLoading}
                  className={`relative overflow-hidden px-4 py-3 text-sm sm:text-base font-medium rounded-xl transition-all duration-300 transform hover:scale-[1.02]
                  bg-customPurple hover:bg-purple-700 text-white shadow-xl hover:shadow-purple-500/25 border border-white/20 hover:border-white/40
                  ${isPageLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                  <div className="flex items-center justify-center gap-2">
                    <>
                      <span className="text-lg">🚚</span>
                      <span>Ship Now</span>
                      {selectedRowsForShip.length > 0 && (
                        <span className="ml-1 px-2 py-0.5 bg-white/20 rounded-full text-xs">
                          {selectedRowsForShip.length}
                        </span>
                      )}
                    </>

                  </div>
                </button>
              )}
              {activeTab !== 'Add Shipment list' && (
                (() => {
                  const downloadCount = selectAll
                    ? data.filter(shipment => shipment.partner).length
                    : selectedRows.length;

                  return downloadCount > 0 ? (
                    <div className="sm:col-span-2">
                      <Button
                        onClick={handleDownload}
                        disabled={isloading}
                        className="flex items-center justify-center gap-2 w-full sm:w-[540px] px-5 py-3 text-sm font-medium text-black dark:text-white rounded-xl shadow-md dark:shadow-custom-dark transition-all duration-300 hover:shadow-lg dark:hover:shadow-lg"
                      >
                        {isloading ? (
                          <>
                            <Spinner className="w-4 h-4 animate-spin" />
                            <span>Downloading...</span>
                          </>
                        ) : (
                          <>
                            <FaDownload className="w-4 h-4" />
                            <span>Download Selected ({downloadCount})</span>
                          </>
                        )}
                      </Button>
                    </div>
                  ) : null;
                })()
              )}
            </>
          </div>
          {selectedRowsForShip.length > 0 && (
            <div className="mb-6 relative">
              {/* Background Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-blue-600/10 dark:from-blue-500/20 dark:via-purple-500/20 dark:to-blue-600/20 rounded-2xl blur-xl"></div>

              {/* Main Container */}
              <div className="relative bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border border-blue-200/50 dark:border-blue-800/50 rounded-2xl p-6 shadow-xl dark:shadow-2xl">
                {/* Header Section */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    {/* Icon with animation */}
                    <div className="relative">
                      <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                        <span className="text-white text-xl animate-bounce">📦</span>
                      </div>
                      <div className="absolute -top-1 -right-1 w-6 h-6 bg-gradient-to-r from-green-400 to-green-500 rounded-full flex items-center justify-center shadow-md">
                        <span className="text-white text-xs font-bold">{selectedRowsForShip.length}</span>
                      </div>
                    </div>

                    {/* Title and description */}
                    <div>
                      <h3 className="text-xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-blue-700 bg-clip-text text-transparent">
                        Bulk Shipment Ready
                      </h3>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {selectedRowsForShip.length} order{selectedRowsForShip.length > 1 ? 's' : ''} selected for processing
                      </p>
                    </div>
                  </div>

                  {/* Clear Selection Button */}
                  <button
                    onClick={() => {
                      setSelectedRowsForShip([]);
                      setSelectedRowsData([]);
                      setSelectAllForShip(false);
                    }}
                    className="text-gray-400 hover:text-red-500 transition-colors p-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20"
                    title="Clear Selection"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Stats Grid */}
                {/* <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 rounded-xl p-4 border border-blue-200/50 dark:border-blue-700/50">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-blue-600 dark:text-blue-400">⚖️</span>
                      <span className="text-xs font-medium text-blue-700 dark:text-blue-300 uppercase tracking-wide">Total Weight</span>
                    </div>
                    <div className="text-lg font-bold text-blue-800 dark:text-blue-200">
                      {selectedRowsData.reduce((sum, row) => sum + parseFloat(row.total_weight || 0), 0)}g
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-800/30 rounded-xl p-4 border border-purple-200/50 dark:border-purple-700/50">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-purple-600 dark:text-purple-400">📏</span>
                      <span className="text-xs font-medium text-purple-700 dark:text-purple-300 uppercase tracking-wide">Avg Dimensions</span>
                    </div>
                    <div className="text-sm font-bold text-purple-800 dark:text-purple-200">
                      {Math.round(selectedRowsData.reduce((sum, row) => sum + parseFloat(row.total_length || 0), 0) / selectedRowsData.length)}×
                      {Math.round(selectedRowsData.reduce((sum, row) => sum + parseFloat(row.total_width || 0), 0) / selectedRowsData.length)}×
                      {Math.round(selectedRowsData.reduce((sum, row) => sum + parseFloat(row.total_height || 0), 0) / selectedRowsData.length)}cm
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-800/30 rounded-xl p-4 border border-green-200/50 dark:border-green-700/50">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-green-600 dark:text-green-400">📍</span>
                      <span className="text-xs font-medium text-green-700 dark:text-green-300 uppercase tracking-wide">Most Common Pin</span>
                    </div>
                    <div className="text-lg font-bold text-green-800 dark:text-green-200">
                      {(() => {
                        const pinCounts = {};
                        selectedRowsData.forEach(row => {
                          try {
                            const dropoffLocation = JSON.parse(row.dropoff_location || '{}');
                            const pin = dropoffLocation.zip;
                            if (pin) {
                              pinCounts[pin] = (pinCounts[pin] || 0) + 1;
                            }
                          } catch (e) {
                            // Handle JSON parse error
                          }
                        });
                        const mostCommonPin = Object.keys(pinCounts).reduce((a, b) => pinCounts[a] > pinCounts[b] ? a : b, '');
                        return mostCommonPin || 'N/A';
                      })()}
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/30 dark:to-orange-800/30 rounded-xl p-4 border border-orange-200/50 dark:border-orange-700/50">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-orange-600 dark:text-orange-400">💰</span>
                      <span className="text-xs font-medium text-orange-700 dark:text-orange-300 uppercase tracking-wide">Total Value</span>
                    </div>
                    <div className="text-lg font-bold text-orange-800 dark:text-orange-200">
                      ₹{selectedRowsData.reduce((sum, row) => {
                        try {
                          const invoices = JSON.parse(row.invoices || '[]');
                          const invoiceAmount = invoices.length > 0 ? invoices[0].inv_amt || 0 : 0;
                          return sum + parseFloat(invoiceAmount);
                        } catch (e) {
                          return sum + parseFloat(row.cod_amount || 0);
                        }
                      }, 0).toLocaleString()}
                    </div>
                  </div>
                </div> */}

                {/* Order Preview */}
                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                    Selected Orders Preview
                  </h4>

                  <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 max-h-60 overflow-y-auto custom-scrollbar transition-all duration-300">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                      {visibleOrders.map((order, index) => {
                        let customerName = "Unknown Customer";
                        try {
                          const dropoffLocation = JSON.parse(order.dropoff_location || "{}");
                          customerName = order.first_name + " " + order.last_name || "Unknown Customer";
                        } catch (e) { }

                        return (
                          <div
                            key={index}
                            className="flex items-center gap-2 p-2 bg-white dark:bg-gray-700 rounded-lg shadow-sm"
                          >
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs font-medium text-gray-900 dark:text-gray-100 truncate">
                                {order.order_id}
                              </p>
                              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                                {customerName}
                              </p>
                            </div>
                            <span className="text-xs font-medium text-green-600 dark:text-green-400">
                              ₹
                              {(() => {
                                try {
                                  const invoices = JSON.parse(order.invoices || "[]");
                                  return invoices.length > 0
                                    ? invoices[0].inv_amt || order.cod_amount
                                    : order.cod_amount;
                                } catch (e) {
                                  return order.cod_amount;
                                }
                              })()}
                            </span>
                          </div>
                        );
                      })}

                      {!showAll && selectedRowsData.length > 6 && (
                        <button
                          onClick={() => setShowAll(true)}
                          className="flex items-center justify-center p-2 bg-gray-100 dark:bg-gray-700 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600 transition-all duration-200"
                        >
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            +{selectedRowsData.length - 6} more orders
                          </span>
                        </button>
                      )}

                      {showAll && selectedRowsData.length > 6 && (
                        <button
                          onClick={() => setShowAll(false)}
                          className="flex items-center justify-center p-2 bg-gray-100 dark:bg-gray-700 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600 transition-all duration-200"
                        >
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            Show less
                          </span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Progress Indicator */}
                {isPageLoading && (
                  <div className="mt-4">
                    <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-400 mb-2">
                      <span>Processing bulk shipment...</span>
                      <span>{selectedRowsForShip.length} orders</span>
                    </div>
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-pulse"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {activeTab === 'Add Shipment list' && (
            <div className={`rounded-custom overflow-x-auto  ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-white'}`}>
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="ml-2 text-xs text-blue-500">Loading All Added Orders...</span>
                </div>
              ) : displayCustomers.length > 0 ? (
                <>
                  <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                    <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                      <tr>
                        <th className='p-2 text-left font-medium'>
                          <input
                            type="checkbox"
                            checked={selectAllForShip}
                            onChange={handleSelectAllForShip}
                            className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </th>
                        <th className='p-2 text-left font-medium'>Order ID</th>
                        {role === 'admin' && <th className='p-2 text-left font-medium'>User ID</th>}
                        <th className='p-2 text-left font-medium'>Customer Info</th>
                        <th className='p-2 text-left font-medium'>Product Details</th>
                        <th className='p-2 text-left font-medium'>Payment</th>
                        <th className='p-2 text-left font-medium'>Status</th>
                        <th className='p-2 text-left font-medium'>Date</th>
                        <th className='p-2 text-left font-medium'>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {displayCustomers.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${selectedRowsForShip.includes(index)
                            ? 'bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500'
                            : index % 2 === 0
                              ? 'bg-white dark:bg-darkmodeColor'
                              : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className='p-2'>
                            <input
                              type="checkbox"
                              checked={selectedRowsForShip.includes(index)}
                              onChange={() => handleRowSelectForShip(index)}
                              className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </td>

                          {/* Order ID */}
                          <td className="relative group p-2 text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors">
                            {row.order_id || 'Unavailable'}
                          </td>

                          {/* User ID for admin */}
                          {role === 'admin' && (
                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                              {row.user_id}
                            </td>
                          )}

                          {/* Customer Info */}
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                            <div className="font-semibold">{row.first_name} {row.last_name}</div>
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">{row.phone}</div>
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">{row.email}</div>
                          </td>

                          {/* Product Details */}
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>
                            <div className="font-medium">{row.products_desc}</div>
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">
                              Qty: {row.quantity} | Weight: {row.weight}g
                            </div>
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">
                              {row.length}×{row.shipment_width}×{row.shipment_height}cm
                            </div>
                          </td>

                          {/* Payment Info */}
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>
                            <div className="font-semibold text-green-600 dark:text-green-400">
                              ₹{row.total_amount}
                            </div>
                            {row.payment_mode === 'cod' && (
                              <div className="text-[10px] text-orange-600 dark:text-orange-400">
                                COD: ₹{row.cod_amount}
                              </div>
                            )}
                            <div className="text-[10px] text-gray-500 dark:text-gray-400 uppercase">
                              {row.payment_mode}
                            </div>
                          </td>

                          {/* Status */}
                          <td className='p-2'>
                            {row.status?.length > 15 ? (
                              <div className="group relative">
                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${row.status === 'Manifested'
                                  ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                  : row.status.toLowerCase() === 'in transit'
                                    ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                            : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                  }`}>
                                  <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                    ? 'bg-white animate-pulse'
                                    : row.status === 'In Transit'
                                      ? 'bg-white animate-bounce'
                                      : row.status.toLowerCase() === 'out for delivery'
                                        ? 'bg-white animate-bounce'
                                        : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                          ? 'bg-white'
                                          : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                            ? 'bg-white animate-pulse'
                                            : row.status.toLowerCase() === 'pending'
                                              ? 'bg-white animate-pulse'
                                              : 'bg-gray-400 dark:bg-gray-500'
                                    }`}></span>
                                  {row.status.substring(0, 8)}...
                                </span>
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                  {row.status}
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                                </div>
                              </div>
                            ) : (
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${row.status === 'Manifested'
                                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                : row.status === 'In Transit'
                                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                  : row.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                    : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                      : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                        : row.status.toLowerCase() === 'pending'
                                          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                          : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                  ? 'bg-white animate-pulse'
                                  : row.status === 'In Transit'
                                    ? 'bg-white animate-bounce'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-white animate-bounce'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-white'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-white animate-pulse'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-white animate-pulse'
                                            : 'bg-gray-400 dark:bg-gray-500'
                                  }`}></span>
                                {row.status}
                              </span>
                            )}
                          </td>

                          {/* Date */}
                          <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {new Date(row.created_at).toLocaleDateString('en-IN', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">
                              {new Date(row.created_at).toLocaleTimeString('en-IN', {
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </div>
                          </td>

                          {/* Actions */}
                          <td className='p-2'>
                            <div className='flex items-center gap-1'>
                              <Button
                                onClick={() => handleViewClick(row)}
                                variant="contained"
                                color="primary"
                                size="small"
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: '#3b82f6',
                                  '&:hover': { backgroundColor: '#2563eb' }
                                }}
                              >
                                <IoMdEye className="text-xs" />
                              </Button>

                              <Button
                                onClick={() => handleShipNow(row)}
                                variant="contained"
                                size="small"
                                disabled={loadingOrderIdShip === row.order_id || row.status === "Delivered" || row.status === "cancel"}
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow group relative"
                                style={{
                                  backgroundColor: '#10b981',
                                  '&:hover': { backgroundColor: '#059669' }
                                }}
                              >
                                {loadingOrderIdShip === row.order_id ? (
                                  <span className="animate-spin text-xs inline-block">⟳</span>
                                ) : (
                                  <span className="text-xs">🚚</span>
                                )}
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                  Ship Now
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-gray-900 dark:border-t-gray-800"></div>
                                </div>
                              </Button>

                              <Button
                                onClick={() => handleCancelOrder(row.order_id)}
                                variant="contained"
                                color="error"
                                size="small"
                                disabled={loadingOrderIdCancleOrder === row.order_id || row.status === "cancel"}
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: '#ef4444',
                                  '&:hover': { backgroundColor: '#dc2626' }
                                }}
                              >
                                {loadingOrderIdCancleOrder === row.order_id ? (
                                  <span className="animate-spin text-xs">⏳</span>
                                ) : (
                                  <RxCross2 className="text-xs" />
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                    <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Orders: ${totalOrders}`}</span>
                    <select
                      id="limit"
                      value={limit}
                      disabled={totalOrders < 10}
                      onChange={handleLimitChange}
                      className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                    >
                      {totalOrders === 0 ? (
                        <option value={0}>0</option>
                      ) : (
                        <>
                          <option value={10}>10</option>
                          <option value={15}>15</option>
                          <option value={20}>20</option>
                          <option value={30}>30</option>
                          <option value={totalOrders}>All</option>
                        </>
                      )}
                    </select>
                    <Pagination
                      count={Math.ceil(totalOrders / limit)}
                      page={currentPage}
                      onChange={handlePaginationChange}
                      variant="outlined"
                      shape="rounded"
                      className="pagination"
                      size="small"
                      renderItem={(item) => (
                        <PaginationItem
                          {...item}
                          className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                        />
                      )}
                    />
                  </div>
                </>
              ) : (
                <div className="text-center text-gray-500 py-4 text-xs">No Data Found</div>
              )}
            </div>
          )}
          {activeTab === 'new order' && (
            <div className={`rounded-custom overflow-x-auto custom-scrollbar ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-white'}`}>
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="ml-2 text-xs text-blue-500">Loading process orders...</span>
                </div>
              ) : displayCustomers.length > 0 ? (
                <>
                  <table className="min-w-full table-auto overflow-y-auto">
                    <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                      <tr>
                        <th className='p-2 text-left font-semibold'>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </th>
                        <th className='p-2 text-left font-semibold'>Order ID</th>
                        {role === 'admin' && <th className='p-2 text-left font-semibold'>User _Id</th>}
                        <th className='p-2 text-left font-semibold'>Partner</th>
                        <th className='p-2 text-left font-semibold'>Customer Info</th>
                        <th className='p-2 text-left font-semibold'>Amount</th>
                        <th className='p-2 text-left font-semibold'>Mode</th>
                        <th className='p-2 text-left font-semibold'>Waybill</th>
                        <th className='p-2 text-left font-semibold'>Status</th>
                        <th className='p-2 text-left font-semibold'>Date</th>
                        <th className='p-2 text-left font-semibold'>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {displayCustomers.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className='p-2'>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                              className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </td>

                          {/* Order ID */}
                          <td
                            className="relative group p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                            onClick={() => handleClick(row.order_id)}
                          >
                            {row.order_id || 'Unavailable'}
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                              📦 Track your shipment status here!
                              <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
                            </div>
                          </td>

                          {/* User ID - only show for admin */}
                          {role === 'admin' && (
                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                              {row.user_id || 'Unavailable'}
                            </td>
                          )}

                          {/* Partner */}
                          <td className='p-2'>
                            <div className="flex items-center">
                              {row.partner ? (
                                <>
                                  {row.partner?.toLowerCase() === "delhivery" && (
                                    <div className="flex items-center">
                                      {isDarkMode ? (
                                        <img
                                          src="/assets/images/DELHIVERYWhite.png"
                                          alt="Delhivery"
                                          className="h-2 w-auto object-contain"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/images/Delhivery.png"
                                          alt="Delhivery"
                                          className="h-2 w-auto object-contain"
                                        />
                                      )}
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "ecom" && (
                                    <div className="flex items-center rounded-full">
                                      {isDarkMode ? (
                                        <img
                                          src="/assets/images/logoecom.svg"
                                          alt="Ecom Express"
                                          className="h-3 w-auto object-contain"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/images/ecom-express-logo.png"
                                          alt="Ecom Express"
                                          className="h-14 w-auto object-contain"
                                        />
                                      )}
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "ekart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/ekart.png"
                                        alt="Ekart"
                                        className="h-9 w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "xpressbees" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/xpressbess.png"
                                        alt="xpressbess"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "bluedart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/bluedart.png"
                                        alt="bluedart"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(row.partner?.toLowerCase()) && (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                                      {row.partner}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200">
                                  Unavailable
                                </span>
                              )}
                            </div>
                          </td>

                          {/* Customer Info */}
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                            {row.first_name || 'Unavailable'}
                          </td>

                          {/* Amount */}
                          <td className='p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold'>
                            {row.debit_amount ? `₹${row.debit_amount}` : 'Unavailable'}
                          </td>

                          {/* Shipping Mode */}
                          <td className="p-2">
                            <div className="flex items-center">
                              {row.shipping_mode === 'surface' && (
                                <div className="flex items-center gap-1 text-blue-600 dark:text-blue-400">
                                  <FaTruck className="text-xs" />
                                </div>
                              )}
                              {row.shipping_mode === 'express' && (
                                <div className="flex items-center gap-1 text-green-600 dark:text-green-400">
                                  <IoMdAirplane className="text-xs" />
                                </div>
                              )}
                              {!row.shipping_mode && (
                                <span className="text-xs text-gray-500 dark:text-gray-400">Unavailable</span>
                              )}
                            </div>
                          </td>

                          {/* Waybill */}
                          <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {row.waybill || row.awb_number || 'Unavailable'}
                          </td>

                          {/* Status */}
                          <td className='p-2'>
                            {row.status?.length > 15 ? (
                              <div className="group relative">
                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${row.status === 'Manifested'
                                  ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                  : row.status.toLowerCase() === 'in transit'
                                    ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                            : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                  }`}>
                                  <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                    ? 'bg-white animate-pulse'
                                    : row.status === 'In Transit'
                                      ? 'bg-white animate-bounce'
                                      : row.status.toLowerCase() === 'out for delivery'
                                        ? 'bg-white animate-bounce'
                                        : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                          ? 'bg-white'
                                          : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                            ? 'bg-white animate-pulse'
                                            : row.status.toLowerCase() === 'pending'
                                              ? 'bg-white animate-pulse'
                                              : 'bg-gray-400 dark:bg-gray-500'
                                    }`}></span>
                                  {row.status.substring(0, 8)}...
                                </span>
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                  {row.status}
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                                </div>
                              </div>
                            ) : (
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${row.status === 'Manifested'
                                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                : row.status === 'In Transit'
                                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                  : row.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                    : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                      : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                        : row.status.toLowerCase() === 'pending'
                                          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                          : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                  ? 'bg-white animate-pulse'
                                  : row.status === 'In Transit'
                                    ? 'bg-white animate-bounce'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-white animate-bounce'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-white'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-white animate-pulse'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-white animate-pulse'
                                            : 'bg-gray-400 dark:bg-gray-500'
                                  }`}></span>
                                {row.status}
                              </span>
                            )}
                          </td>

                          {/* Date */}
                          <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {new Date(row.created_at).toLocaleDateString('en-IN', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">
                              {new Date(row.created_at).toLocaleTimeString('en-IN', {
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </div>
                          </td>
                          {/* Actions */}
                          <td className='p-2'>
                            <div className='flex items-center gap-1'>
                              <Button
                                onClick={() => handleViewClick(row)}
                                variant="contained"
                                color="primary"
                                size="small"
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: '#3b82f6',
                                  '&:hover': { backgroundColor: '#2563eb' }
                                }}
                              >
                                <IoMdEye className="text-xs" />
                              </Button>
                              <Button
                                onClick={() => handlePrintLabel(row.order_id)}
                                variant="contained"
                                color="secondary"
                                size="small"
                                disabled={loadingOrderId === row.order_id || !row.order_id}
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: row.order_id ? '#8b5cf6' : '#9ca3af',
                                  '&:hover': { backgroundColor: row.order_id ? '#7c3aed' : '#9ca3af' }
                                }}
                              >
                                {loadingOrderId === row.order_id ? (
                                  <span className="animate-spin">
                                    <FcPrint className="text-xs" />
                                  </span>
                                ) : (
                                  <FcPrint className="text-xs" />
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                    <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Orders: ${totalOrders}`}</span>
                    <select
                      id="limit"
                      value={limit}
                      onChange={handleLimitChange}
                      className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                      disabled={totalOrders < 10}
                    >
                      {totalOrders === 0 ? (
                        <option value={0}>0</option>
                      ) : (
                        <>
                          <option value={10}>10</option>
                          <option value={15}>15</option>
                          <option value={20}>20</option>
                          <option value={30}>30</option>
                          <option value={totalOrders}>All</option>
                        </>
                      )}
                    </select>

                    <Pagination
                      count={Math.ceil(totalOrders / limit)}
                      page={currentPage}
                      onChange={handlePaginationChange}
                      variant="outlined"
                      shape="rounded"
                      className="pagination"
                      size="small"
                      renderItem={(item) => (
                        <PaginationItem
                          {...item}
                          className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                        />
                      )}
                    />
                  </div>
                </>
              ) : (
                <div className="text-center text-gray-500 py-4 text-xs">No process orders today</div>
              )}
            </div>
          )}
          {activeTab === 'process order' && (
            <div className={`rounded-custom overflow-x-auto custom-scrollbar  ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-white'}`}>
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="ml-2 text-xs text-blue-500">Loading porcess orders...</span>
                </div>
              ) : displayCustomers.length > 0 ? (
                <>
                  <table className="min-w-full table-auto overflow-y-auto">
                    <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                      <tr>
                        <th className='p-2 text-left font-semibold'>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </th>
                        <th className='p-2 text-left font-semibold'>Order ID</th>
                        {role === 'admin' && <th className='p-2 text-left font-semibold'>User _Id</th>}
                        <th className='p-2 text-left font-semibold'>Partner</th>
                        <th className='p-2 text-left font-semibold'>Customer Info</th>
                        <th className='p-2 text-left font-semibold'>Amount</th>
                        <th className='p-2 text-left font-semibold'>Mode</th>
                        <th className='p-2 text-left font-semibold'>Waybill</th>
                        <th className='p-2 text-left font-semibold'>Status</th>
                        <th className='p-2 text-left font-semibold'>Date</th>
                        <th className='p-2 text-left font-semibold'>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {displayCustomers.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className='p-2'>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                              className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </td>

                          {/* Order ID */}
                          <td
                            className="relative group p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                            onClick={() => handleClick(row.order_id)}
                          >
                            {row.order_id || 'Unavailable'}
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                              📦 Track your shipment status here!
                              <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
                            </div>
                          </td>

                          {/* User ID - only show for admin */}
                          {role === 'admin' && (
                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                              {row.user_id || 'Unavailable'}
                            </td>
                          )}

                          {/* Partner */}
                          <td className='p-2'>
                            <div className="flex items-center">
                              {row.partner ? (
                                <>
                                  {row.partner?.toLowerCase() === "delhivery" && (
                                    <div className="flex items-center">
                                      {isDarkMode ? (
                                        <img
                                          src="/assets/images/DELHIVERYWhite.png"
                                          alt="Delhivery"
                                          className="h-2 w-auto object-contain"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/images/Delhivery.png"
                                          alt="Delhivery"
                                          className="h-2 w-auto object-contain"
                                        />
                                      )}
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "ecom" && (
                                    <div className="flex items-center rounded-full">
                                      {isDarkMode ? (
                                        <img
                                          src="/assets/images/logoecom.svg"
                                          alt="Ecom Express"
                                          className="h-3 w-auto object-contain"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/images/ecom-express-logo.png"
                                          alt="Ecom Express"
                                          className="h-14 w-auto object-contain"
                                        />
                                      )}
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "ekart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/ekart.png"
                                        alt="Ekart"
                                        className="h-9 w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "xpressbees" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/xpressbess.png"
                                        alt="xpressbess"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "bluedart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/bluedart.png"
                                        alt="bluedart"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(row.partner?.toLowerCase()) && (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                                      {row.partner}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200">
                                  Unavailable
                                </span>
                              )}
                            </div>
                          </td>

                          {/* Customer Info */}
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                            {row.first_name || 'Unavailable'}
                          </td>

                          {/* Amount */}
                          <td className='p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold'>
                            {row.debit_amount ? `₹${row.debit_amount}` : 'Unavailable'}
                          </td>

                          {/* Shipping Mode */}
                          <td className="p-2">
                            <div className="flex items-center">
                              {row.shipping_mode === 'surface' && (
                                <div className="flex items-center gap-1 text-blue-600 dark:text-blue-400">
                                  <FaTruck className="text-xs" />
                                </div>
                              )}
                              {row.shipping_mode === 'express' && (
                                <div className="flex items-center gap-1 text-green-600 dark:text-green-400">
                                  <IoMdAirplane className="text-xs" />
                                </div>
                              )}
                              {!row.shipping_mode && (
                                <span className="text-xs text-gray-500 dark:text-gray-400">Unavailable</span>
                              )}
                            </div>
                          </td>

                          {/* Waybill */}
                          <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {row.waybill || row.awb_number || 'Unavailable'}
                          </td>

                          {/* Status */}
                          <td className='p-2'>
                            {row.status?.length > 15 ? (
                              <div className="group relative">
                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${row.status === 'Manifested'
                                  ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                  : row.status.toLowerCase() === 'in transit'
                                    ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                            : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                  }`}>
                                  <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                    ? 'bg-white animate-pulse'
                                    : row.status === 'In Transit'
                                      ? 'bg-white animate-bounce'
                                      : row.status.toLowerCase() === 'out for delivery'
                                        ? 'bg-white animate-bounce'
                                        : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                          ? 'bg-white'
                                          : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                            ? 'bg-white animate-pulse'
                                            : row.status.toLowerCase() === 'pending'
                                              ? 'bg-white animate-pulse'
                                              : 'bg-gray-400 dark:bg-gray-500'
                                    }`}></span>
                                  {row.status.substring(0, 8)}...
                                </span>
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                  {row.status}
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                                </div>
                              </div>
                            ) : (
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${row.status === 'Manifested'
                                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                : row.status === 'In Transit'
                                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                  : row.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                    : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                      : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                        : row.status.toLowerCase() === 'pending'
                                          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                          : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                  ? 'bg-white animate-pulse'
                                  : row.status === 'In Transit'
                                    ? 'bg-white animate-bounce'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-white animate-bounce'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-white'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-white animate-pulse'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-white animate-pulse'
                                            : 'bg-gray-400 dark:bg-gray-500'
                                  }`}></span>
                                {row.status}
                              </span>
                            )}
                          </td>

                          {/* Date */}
                          <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {new Date(row.created_at).toLocaleDateString('en-IN', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                            <div className="text-[10px] text-gray-500 dark:text-gray-400">
                              {new Date(row.created_at).toLocaleTimeString('en-IN', {
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </div>
                          </td>

                          {/* Actions */}
                          <td className='p-2'>
                            <div className='flex items-center gap-1'>
                              <Button
                                onClick={() => handleViewClick(row)}
                                variant="contained"
                                color="primary"
                                size="small"
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: '#3b82f6',
                                  '&:hover': { backgroundColor: '#2563eb' }
                                }}
                              >
                                <IoMdEye className="text-xs" />
                              </Button>
                              <Button
                                onClick={() => handlePrintLabel(row.order_id)}
                                variant="contained"
                                color="secondary"
                                size="small"
                                disabled={loadingOrderId === row.order_id || !row.order_id}
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: row.order_id ? '#8b5cf6' : '#9ca3af',
                                  '&:hover': { backgroundColor: row.order_id ? '#7c3aed' : '#9ca3af' }
                                }}
                              >
                                {loadingOrderId === row.order_id ? (
                                  <span className="animate-spin">
                                    <FcPrint className="text-xs" />
                                  </span>
                                ) : (
                                  <FcPrint className="text-xs" />
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                    <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Orders: ${totalOrders}`}</span>
                    <select
                      id="limit"
                      value={limit}
                      onChange={handleLimitChange}
                      className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                      disabled={totalOrders < 10}
                    >
                      {totalOrders === 0 ? (
                        <option value={0}>0</option>
                      ) : (
                        <>
                          <option value={10}>10</option>
                          <option value={15}>15</option>
                          <option value={20}>20</option>
                          <option value={30}>30</option>
                          <option value={totalOrders}>All</option>
                        </>
                      )}
                    </select>

                    <Pagination
                      count={Math.ceil(totalOrders / limit)}
                      page={currentPage}
                      onChange={handlePaginationChange}
                      variant="outlined"
                      shape="rounded"
                      className="pagination"
                      size="small"
                      renderItem={(item) => (
                        <PaginationItem
                          {...item}
                          className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                        />
                      )}
                    />
                  </div>
                </>
              ) : (
                <div className="text-center text-gray-500 py-4 text-xs">No process orders today</div>
              )}
            </div>
          )}
          {activeTab === 'manifest list' && (
            <div className={`rounded-custom overflow-x-auto custom-scrollbar ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-white'}`}>
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="ml-2 text-xs text-blue-500">Loading menifest orders...</span>
                </div>
              ) : displayCustomers.length > 0 ? (
                <>
                  <table className="min-w-full table-auto overflow-y-auto">
                    <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                      <tr>
                        <th className='p-2 text-left font-semibold'>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </th>
                        <th className='p-2 text-left font-semibold'>Order ID</th>
                        {role === 'admin' && <th className='p-2 text-left font-semibold'>User _Id</th>}
                        <th className='p-2 text-left font-semibold'>Partner</th>
                        <th className='p-2 text-left font-semibold'>Customer Info</th>
                        <th className='p-2 text-left font-semibold'>Amount</th>
                        <th className='p-2 text-left font-semibold'>Mode</th>
                        <th className='p-2 text-left font-semibold'>Waybill</th>
                        <th className='p-2 text-left font-semibold'>Status</th>
                        <th className='p-2 text-left font-semibold'>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {displayCustomers.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className='p-2'>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                              className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </td>

                          {/* Order ID */}
                          <td
                            className="relative group p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                            onClick={() => handleClick(row.order_id)}
                          >
                            {row.order_id || 'Unavailable'}
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                              📦 Track your shipment status here!
                              <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
                            </div>
                          </td>

                          {/* User ID - only show for admin */}
                          {role === 'admin' && (
                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                              {row.user_id || 'Unavailable'}
                            </td>
                          )}

                          {/* Partner */}
                          <td className='p-2'>
                            <div className="flex items-center">
                              {row.partner ? (
                                <>
                                  {row.partner?.toLowerCase() === "delhivery" && (
                                    <div className="flex items-center">
                                      {/* <img
                                        src="/assets/images/Delhivery.png"
                                        alt="Delhivery"
                                        className="h-2 w-auto object-contain"
                                      /> */}
                                      {isDarkMode ? (
                                        <img
                                          src="/assets/images/DELHIVERYWhite.png"
                                          alt="Delhivery"
                                          className="h-2 w-auto object-contain"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/images/Delhivery.png"
                                          alt="Delhivery"
                                          className="h-2 w-auto object-contain"
                                        />
                                      )}
                                    </div>

                                  )}
                                  {row.partner?.toLowerCase() === "ecom" && (
                                    <div className="flex items-center rounded-full">
                                      {isDarkMode ? (
                                        <img
                                          src="/assets/images/logoecom.svg"
                                          alt="Ecom Express"
                                          className="h-3 w-auto object-contain"
                                        />
                                      ) : (
                                        <img
                                          src="/assets/images/ecom-express-logo.png"
                                          alt="Ecom Express"
                                          className="h-14 w-auto object-contain"
                                        />
                                      )}
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "ekart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/ekart.png"
                                        alt="Ekart"
                                        className="h-9 w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "xpressbees" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/xpressbess.png"
                                        alt="xpressbess"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {row.partner?.toLowerCase() === "bluedart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/bluedart.png"
                                        alt="bluedart"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(row.partner?.toLowerCase()) && (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                                      {row.partner}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200">
                                  Unavailable
                                </span>
                              )}
                            </div>
                          </td>

                          {/* Customer Info */}
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                            {row.first_name || 'Unavailable'}
                          </td>

                          {/* Amount */}
                          <td className='p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold'>
                            {row.debit_amount ? `₹${row.debit_amount}` : 'Unavailable'}
                          </td>

                          {/* Shipping Mode */}
                          <td className="p-2">
                            <div className="flex items-center">
                              {row.shipping_mode === 'surface' && (
                                <div className="flex items-center gap-1 text-blue-600 dark:text-blue-400">
                                  <FaTruck className="text-xs" />
                                </div>
                              )}
                              {row.shipping_mode === 'express' && (
                                <div className="flex items-center gap-1 text-green-600 dark:text-green-400">
                                  <IoMdAirplane className="text-xs" />
                                </div>
                              )}
                              {!row.shipping_mode && (
                                <span className="text-xs text-gray-500 dark:text-gray-400">Unavailable</span>
                              )}
                            </div>
                          </td>

                          {/* Waybill */}
                          <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {row.waybill || row.awb_number || 'Unavailable'}
                          </td>

                          {/* Status */}
                          <td className='p-2'>
                            {row.status?.length > 15 ? (
                              <div className="group relative">
                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${row.status === 'Manifested'
                                  ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                  : row.status.toLowerCase() === 'in transit'
                                    ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                            : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                  }`}>
                                  <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                    ? 'bg-white animate-pulse'
                                    : row.status === 'In Transit'
                                      ? 'bg-white animate-bounce'
                                      : row.status.toLowerCase() === 'out for delivery'
                                        ? 'bg-white animate-bounce'
                                        : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                          ? 'bg-white'
                                          : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                            ? 'bg-white animate-pulse'
                                            : row.status.toLowerCase() === 'pending'
                                              ? 'bg-white animate-pulse'
                                              : 'bg-gray-400 dark:bg-gray-500'
                                    }`}></span>
                                  {row.status.substring(0, 8)}...
                                </span>
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                  {row.status}
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                                </div>
                              </div>
                            ) : (
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${row.status === 'Manifested'
                                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                : row.status === 'In Transit'
                                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                  : row.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                    : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                      : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                        : row.status.toLowerCase() === 'pending'
                                          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                          : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                  ? 'bg-white animate-pulse'
                                  : row.status === 'In Transit'
                                    ? 'bg-white animate-bounce'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-white animate-bounce'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-white'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-white animate-pulse'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-white animate-pulse'
                                            : 'bg-gray-400 dark:bg-gray-500'
                                  }`}></span>
                                {row.status}
                              </span>
                            )}
                          </td>

                          {/* Date */}
                          {/* <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                            {row.order_date || row.created_at?.split(' ')[0] || 'Unavailable'}
                          </td> */}

                          {/* Actions */}
                          <td className='p-2'>
                            <div className='flex items-center gap-1'>
                              <Button
                                onClick={() => handleViewClick(row)}
                                variant="contained"
                                color="primary"
                                size="small"
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: '#3b82f6',
                                  '&:hover': { backgroundColor: '#2563eb' }
                                }}
                              >
                                <IoMdEye className="text-xs" />
                              </Button>
                              <Button
                                onClick={() => handlePrintLabel(row.order_id)}
                                variant="contained"
                                color="secondary"
                                size="small"
                                disabled={loadingOrderId === row.order_id || !row.order_id}
                                className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                style={{
                                  backgroundColor: row.order_id ? '#8b5cf6' : '#9ca3af',
                                  '&:hover': { backgroundColor: row.order_id ? '#7c3aed' : '#9ca3af' }
                                }}
                              >
                                {loadingOrderId === row.order_id ? (
                                  <span className="animate-spin">
                                    <FcPrint className="text-xs" />
                                  </span>
                                ) : (
                                  <FcPrint className="text-xs" />
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                    <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Orders: ${totalOrders}`}</span>
                    <select
                      id="limit"
                      value={limit}
                      onChange={handleLimitChange}
                      className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                      disabled={totalOrders < 10}
                    >
                      {totalOrders === 0 ? (
                        <option value={0}>0</option>
                      ) : (
                        <>
                          <option value={10}>10</option>
                          <option value={15}>15</option>
                          <option value={20}>20</option>
                          <option value={30}>30</option>
                          <option value={totalOrders}>All</option>
                        </>
                      )}
                    </select>

                    <Pagination
                      count={Math.ceil(totalOrders / limit)}
                      page={currentPage}
                      onChange={handlePaginationChange}
                      variant="outlined"
                      shape="rounded"
                      className="pagination"
                      size="small"
                      renderItem={(item) => (
                        <PaginationItem
                          {...item}
                          className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                        />
                      )}
                    />
                  </div>
                </>
              ) : (
                <div className="text-center text-gray-500 py-4">No manifest orders available</div>
              )}
            </div>
          )}
          {activeTab === 'all orders' && (
            <div className={`rounded-custom overflow-x-auto  ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-white'}`}>
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="ml-2 text-xs text-blue-500">Loading All Orders...</span>
                </div>
              ) : displayCustomers.length > 0 ? (
                <>
                  {(() => {
                    const filteredCustomers = statusFilter
                      ? displayCustomers.filter(row => {
                        const rowStatus = row.status?.toLowerCase() || '';
                        const filterValue = statusFilter.toLowerCase();

                        // Exact matching for specific statuses
                        if (filterValue === 'manifested') {
                          return rowStatus === 'manifested';
                        } else if (filterValue === 'pickup scheduled') {
                          return rowStatus === 'pickup scheduled';
                        } else if (filterValue === 'out for pickup') {
                          return rowStatus === 'out for pickup';
                        } else if (filterValue === 'out for delivery') {
                          return rowStatus === 'out for delivery';
                        } else if (filterValue === 'delivered to consignee') {
                          return rowStatus === 'delivered to consignee';
                        }

                        return rowStatus.includes(filterValue);
                      })
                      : displayCustomers;

                    return (
                      <>
                        <table className="min-w-full table-auto overflow-y-auto">
                          <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                            <tr>
                              <th className='p-2 text-left font-semibold'>
                                <input
                                  type="checkbox"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                  className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                                />
                              </th>
                              <th className='p-2 text-left font-semibold'>Order ID</th>
                              {role === 'admin' && <th className='p-2 text-left font-semibold'>User _Id</th>}
                              <th className='p-2 text-left font-semibold'>Partner</th>
                              <th className='p-2 text-left font-semibold'>Customer Info</th>
                              <th className='p-2 text-left font-semibold'>Amount</th>
                              <th className='p-2 text-left font-semibold'>Mode</th>
                              <th className='p-2 text-left font-semibold'>Waybill</th>
                              <th className="p-2 text-left font-semibold">
                                <div className="flex flex-col gap-1">
                                  {/* <span className="whitespace-nowrap">Status</span> */}
                                  <select
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="text-white w-24 px-1  border border-white dark:border-white rounded-md text-[10px] bg-customPurple dark:bg-darkmodeColor dark:text-white"
                                  >
                                    <option value="">All</option>
                                    <option value="manifested">Manifested</option>
                                    <option value="pickup scheduled">Pickup Scheduled</option>
                                    <option value="out for pickup">Out for Pickup</option>
                                    <option value="out for delivery">Out for Delivery</option>
                                    <option value="delivered to consignee">Delivered to Consignee</option>
                                  </select>
                                </div>

                              </th>
                              <th className='p-2 text-left font-semibold'>Date</th>
                              <th className='p-2 text-left font-semibold'>Actions</th>
                            </tr>
                          </thead>

                          <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                            {filteredCustomers.map((row, index) => (
                              <tr
                                key={index}
                                className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                                  ? 'bg-white dark:bg-darkmodeColor'
                                  : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                                  }`}
                              >
                                <td className='p-2'>
                                  <input
                                    type="checkbox"
                                    checked={selectedRows.includes(index)}
                                    onChange={() => handleRowSelect(index)}
                                    className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                                  />
                                </td>

                                {/* Order ID */}
                                <td
                                  className="relative group p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                                  onClick={() => handleClick(row.order_id)}
                                >
                                  {row.order_id || 'Unavailable'}
                                  <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                                    📦 Track your shipment status here!
                                    <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
                                  </div>
                                </td>

                                {/* User ID - only show for admin */}
                                {role === 'admin' && (
                                  <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                                    {row.user_id || 'Unavailable'}
                                  </td>
                                )}

                                {/* Partner */}
                                <td className='p-2'>
                                  <div className="flex items-center">
                                    {row.partner ? (
                                      <>
                                        {row.partner?.toLowerCase() === "delhivery" && (
                                          <div className="flex items-center">
                                            {isDarkMode ? (
                                              <img
                                                src="/assets/images/DELHIVERYWhite.png"
                                                alt="Delhivery"
                                                className="h-2 w-auto object-contain"
                                              />
                                            ) : (
                                              <img
                                                src="/assets/images/Delhivery.png"
                                                alt="Delhivery"
                                                className="h-2 w-auto object-contain"
                                              />
                                            )}
                                          </div>
                                        )}
                                        {row.partner?.toLowerCase() === "ecom" && (
                                          <div className="flex items-center rounded-full">
                                            {isDarkMode ? (
                                              <img
                                                src="/assets/images/logoecom.svg"
                                                alt="Ecom Express"
                                                className="h-3 w-auto object-contain"
                                              />
                                            ) : (
                                              <img
                                                src="/assets/images/ecom-express-logo.png"
                                                alt="Ecom Express"
                                                className="h-14 w-auto object-contain"
                                              />
                                            )}
                                          </div>
                                        )}
                                        {row.partner?.toLowerCase() === "ekart" && (
                                          <div className="flex items-center">
                                            <img
                                              src="/assets/images/ekart.png"
                                              alt="Ekart"
                                              className="h-9 w-auto object-contain"
                                            />
                                          </div>
                                        )}
                                        {row.partner?.toLowerCase() === "xpressbees" && (
                                          <div className="flex items-center">
                                            <img
                                              src="/assets/images/xpressbess.png"
                                              alt="xpressbess"
                                              className="h-[10px] w-auto object-contain"
                                            />
                                          </div>
                                        )}
                                        {row.partner?.toLowerCase() === "bluedart" && (
                                          <div className="flex items-center">
                                            <img
                                              src="/assets/images/bluedart.png"
                                              alt="bluedart"
                                              className="h-[10px] w-auto object-contain"
                                            />
                                          </div>
                                        )}
                                        {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(row.partner?.toLowerCase()) && (
                                          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                                            {row.partner}
                                          </span>
                                        )}
                                      </>
                                    ) : (
                                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200">
                                        Unavailable
                                      </span>
                                    )}
                                  </div>
                                </td>

                                {/* Customer Info */}
                                <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                                  {row.first_name || 'Unavailable'}
                                </td>

                                {/* Amount */}
                                <td className='p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold'>
                                  {row.debit_amount ? `₹${row.debit_amount}` : 'Unavailable'}
                                </td>

                                {/* Shipping Mode */}
                                <td className="p-2">
                                  <div className="flex items-center">
                                    {row.shipping_mode === 'surface' && (
                                      <div className="flex items-center gap-1 text-blue-600 dark:text-blue-400">
                                        <FaTruck className="text-xs" />
                                      </div>
                                    )}
                                    {row.shipping_mode === 'express' && (
                                      <div className="flex items-center gap-1 text-green-600 dark:text-green-400">
                                        <IoMdAirplane className="text-xs" />
                                      </div>
                                    )}
                                    {!row.shipping_mode && (
                                      <span className="text-xs text-gray-500 dark:text-gray-400">Unavailable</span>
                                    )}
                                  </div>
                                </td>

                                {/* Waybill */}
                                <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                                  {row.waybill || row.awb_number || 'Unavailable'}
                                </td>

                                {/* Status */}
                                <td className='p-2'>
                                  {row.status?.length > 15 ? (
                                    <div className="group relative">
                                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${row.status === 'Manifested'
                                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                        : row.status.toLowerCase() === 'in transit'
                                          ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                          : row.status.toLowerCase() === 'out for delivery'
                                            ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                            : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                              ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                              : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                                ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                                : row.status.toLowerCase() === 'pending'
                                                  ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                                  : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                        }`}>
                                        <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                          ? 'bg-white animate-pulse'
                                          : row.status === 'In Transit'
                                            ? 'bg-white animate-bounce'
                                            : row.status.toLowerCase() === 'out for delivery'
                                              ? 'bg-white animate-bounce'
                                              : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                                ? 'bg-white'
                                                : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                                  ? 'bg-white animate-pulse'
                                                  : row.status.toLowerCase() === 'pending'
                                                    ? 'bg-white animate-pulse'
                                                    : 'bg-gray-400 dark:bg-gray-500'
                                          }`}></span>
                                        {row.status.substring(0, 8)}...
                                      </span>
                                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                        {row.status}
                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                                      </div>
                                    </div>
                                  ) : (
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${row.status === 'Manifested'
                                      ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                      : row.status === 'In Transit'
                                        ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                        : row.status.toLowerCase() === 'out for delivery'
                                          ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                          : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                            ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                            : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                              ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                              : row.status.toLowerCase() === 'pending'
                                                ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                                : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                      }`}>
                                      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                        ? 'bg-white animate-pulse'
                                        : row.status === 'In Transit'
                                          ? 'bg-white animate-bounce'
                                          : row.status.toLowerCase() === 'out for delivery'
                                            ? 'bg-white animate-bounce'
                                            : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                              ? 'bg-white'
                                              : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                                ? 'bg-white animate-pulse'
                                                : row.status.toLowerCase() === 'pending'
                                                  ? 'bg-white animate-pulse'
                                                  : 'bg-gray-400 dark:bg-gray-500'
                                        }`}></span>
                                      {row.status}
                                    </span>
                                  )}
                                </td>

                                {/* Date */}
                                <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                                  {new Date(row.created_at).toLocaleDateString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                  })}
                                  <div className="text-[10px] text-gray-500 dark:text-gray-400">
                                    {new Date(row.created_at).toLocaleTimeString('en-IN', {
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    })}
                                  </div>
                                </td>

                                {/* Actions */}
                                <td className='p-2'>
                                  <div className='flex items-center gap-1'>
                                    <Button
                                      onClick={() => handleViewClick(row)}
                                      variant="contained"
                                      color="primary"
                                      size="small"
                                      className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                      style={{
                                        backgroundColor: '#3b82f6',
                                        '&:hover': { backgroundColor: '#2563eb' }
                                      }}
                                    >
                                      <IoMdEye className="text-xs" />
                                    </Button>
                                    <Button
                                      onClick={() => handleShipNow(row)}
                                      variant="contained"
                                      size="small"
                                      disabled={
                                        loadingOrderIdShip === row.order_id ||
                                        row.status !== "Pending" ||
                                        row.partner
                                      }
                                      className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow group relative"
                                      style={{
                                        backgroundColor: '#10b981',
                                      }}
                                    >
                                      {loadingOrderIdShip === row.order_id ? (
                                        <span className="animate-spin text-xs inline-block">⟳</span>
                                      ) : (
                                        <span className="text-xs">🚚</span>
                                      )}

                                      {/* Tooltip */}
                                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                        Ship Now
                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-gray-900 dark:border-t-gray-800"></div>
                                      </div>
                                    </Button>

                                    <Button
                                      onClick={() => handlePrintLabel(row.order_id)}
                                      variant="contained"
                                      color="secondary"
                                      size="small"
                                      disabled={
                                        loadingOrderId === row.order_id ||
                                        !row.order_id ||
                                        row.status === "Pending"
                                      }
                                      className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                      style={{
                                        backgroundColor:
                                          row.status === "Pending" || !row.order_id
                                            ? '#9ca3af'
                                            : '#8b5cf6',
                                      }}
                                    >
                                      {loadingOrderId === row.order_id ? (
                                        <span className="animate-spin">
                                          <FcPrint className="text-xs" />
                                        </span>
                                      ) : (
                                        <FcPrint className="text-xs" />
                                      )}
                                    </Button>

                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                          <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Orders: ${totalOrders}`}</span>
                          <select
                            id="limit"
                            value={limit}
                            onChange={handleLimitChange}
                            className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                            disabled={totalOrders < 10}
                          >
                            {totalOrders === 0 ? (
                              <option value={0}>0</option>
                            ) : (
                              <>
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={totalOrders}>All</option>
                              </>
                            )}
                          </select>

                          <Pagination
                            count={Math.ceil(totalOrders / limit)}
                            page={currentPage}
                            onChange={handlePaginationChange}
                            variant="outlined"
                            shape="rounded"
                            className="pagination"
                            size="small"
                            renderItem={(item) => (
                              <PaginationItem
                                {...item}
                                className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                              />
                            )}
                          />
                        </div>
                      </>
                    );
                  })()}
                </>
              ) : (
                <div className="text-center text-gray-500 py-4">No All orders available</div>
              )}
            </div>
          )}
          <ViewAllShipment isopen={isPopupOpen} onClose={handleClose} shipment={selectedShipment} wareHouseList={wareHouseList} fetchOrderData={fetchOrderData} />
          <ViewRateForwardShipment isopen={isPopupOpenForShip} onClose={handleCloseForShip} data={selectedShipment} />
        </div>
      </div>
    </div>
  );
};
export default AllShipment;
